import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import screens from '../@style/screens';
import urlFilename from '../utils/urlFilename';

interface Props {
  data: Queries.ProductsFieldsFragment;
}

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
`;

const ProductWrapper = styled.div`
  width: 100%;
  height: max-content;
  border-radius: 10px;
  border: 2px solid #00a3e0;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
  @media ${screens.laptop} {
    border-radius: 30px;
  }
`;

const Product: React.FC<Props> = ({ data }) => {
  return (
    <ProductWrapper>
      <Link to={`/product/${data.omniItemId}`}>
        <ProductImage
          src={urlFilename(data.epc?.alternative_3dThumbnailUrl) ?? ''}
          alt={data.description ?? ''}
        />
      </Link>
    </ProductWrapper>
  );
};

export default Product;
